// extracted by css-extract-rspack-plugin
export default {"main":"CreateHealthCheckupInstitution__main--8A4f5"};